exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-panel[data-v-0b5a804b]{position:relative;height:250px;font-size:15px;transition:width height .35 ease}.avatar-container[data-v-0b5a804b]{position:relative;height:100px}.avatar-md.bordered[data-v-0b5a804b]{position:absolute;left:0;right:0;margin:auto;width:100px;height:100px;padding:5px;background-color:hsla(0,0%,100%,.25)}.avatar-md img[data-v-0b5a804b]{width:100%;height:100%}.avatar-title[data-v-0b5a804b]{opacity:.8;font-size:40px;font-weight:400;background-color:transparent}", ""]);

// exports
